export function Logo({ dark = false, size = "md" }) {
  const text = dark ? "#FFFFFF" : "#0A1128";
  const h = size === "lg" ? "h-12" : size === "sm" ? "h-7" : "h-9";
  return (
    <div className="flex items-center gap-2.5" data-testid="app-logo">
      <svg viewBox="0 0 48 48" className={`${h} w-auto`} fill="none" aria-label="SOLOContainer logo">
        <rect x="4" y="14" width="34" height="24" rx="2" fill={dark ? "#FFFFFF" : "#0A1128"} />
        <path d="M10 14v24M17 14v24M24 14v24M31 14v24" stroke={dark ? "#0A1128" : "#FFFFFF"} strokeWidth="1.6" />
        <path d="M38 20h6v12h-6" stroke="#00F0FF" strokeWidth="2" fill="none" />
        <circle cx="44" cy="26" r="2.4" fill="#00F0FF" />
        <path d="M4 10l10-6h24l6 6" stroke={dark ? "#FFFFFF" : "#0A1128"} strokeWidth="2.4" fill="none" strokeLinejoin="round" />
        <circle cx="38" cy="8" r="2" fill="#00F0FF" />
      </svg>
      <div className="leading-none">
        <span className="font-outfit font-extrabold tracking-tight text-lg" style={{ color: text }}>
          SOLO<span style={{ color: "#00A8C6" }}>Container</span>
        </span>
        <span className="block text-[9px] uppercase tracking-[0.28em] font-mono" style={{ color: dark ? "#94a3b8" : "#64748b" }}>
          Logistics Tech
        </span>
      </div>
    </div>
  );
}
